export default {
  CONFIANZA_ONLINE: 'confianza-online',
  TRUSTED_SHOPS: 'trusted-shops',
  TRUSTPILOT: 'trustpilot',
  NONE: 'none',
}
